import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import LogoMarquee from "@/components/LogoMarquee";
import Features from "@/components/Features";
import DashboardMockup from "@/components/DashboardMockup";
import MediaBreak from "@/components/MediaBreak";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 selection:bg-emerald-500/30"
    >
      <Seo
        path="/"
        description="Hundify är det smarta affärssystemet för hundpensionat, hunddagis och hundpromenader. Automatiserade bokningar, fakturor och digitala hundprofiler — byggt i Sverige."
      />
      <Navbar />
      <main>
        <Hero />
        <DashboardMockup />
        <LogoMarquee />
        <Features />
        <MediaBreak />
        <Pricing />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
